import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from '../service/translation-loader.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private _translateService: TranslateService,
    public _translationLoaderService: TranslationLoaderService) { }

  ngOnInit() {
  }

}
